import { createContext } from "react";
import type { UnitGroup } from "@/types";

export interface UnitItemContextType {
    unitGroup: UnitGroup;
    selectedPromo: number;
    setSelectedPromo: (value: number) => void;
}

export const UnitItemContext = createContext<UnitItemContextType | null>(null);
